// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { User } from "../../../data/identity/user";
import { UserRole } from "../../../data/identity/user-role";
import { UserClaim } from "../../../data/identity/user-claim";
import { EnvelopeDocument } from "../base/envelope-document";

export class UserDocument extends EnvelopeDocument {
	public override Item: User = new User();
	public UserRoles: UserRole[] = [];
	public UserClaims: UserClaim[] = [];
}